/**
 * Opening marking previews and saving files from the browser.
 *
 * `openMarkingPreviewWindow` writes a standalone document into a popup so a
 * preview can be kept open beside the app while the operator works; passing the
 * previous window back in reuses it instead of stacking popups.
 *
 * `downloadBlob` and `getFilenameFromContentDisposition` are the shared save
 * path: the server names the file it serves, and the caller's name is only the
 * fallback, so a downloaded marking file keeps the name the laser expects.
 */
export function openMarkingPreviewWindow(previewImageBlob, title, existingWindow = null) {
    const previewWindow = existingWindow || window.open("", "_blank", "width=1100,height=900");
    if (!previewWindow) return;
    const imageUrl = URL.createObjectURL(previewImageBlob);
    const html = `
<!doctype html>
<html>
  <head>
    <meta charset="utf-8" />
    <title>${title}</title>
    <style>
      body { font-family: Arial, sans-serif; margin: 0; background: #f8fafc; color: #111827; }
      .header { padding: 12px 16px; background: #ffffff; border-bottom: 1px solid #e5e7eb; }
      .content { padding: 16px; display: flex; justify-content: center; }
      img { max-width: 100%; height: auto; background: #ffffff; border: 1px solid #e5e7eb; }
    </style>
  </head>
  <body>
    <div class="header">${title}</div>
    <div class="content">
      <img alt="${title}" src="${imageUrl}" />
    </div>
  </body>
</html>
`;
    const htmlUrl = URL.createObjectURL(new Blob([html], { type: "text/html" }));
    try {
        previewWindow.location.replace(htmlUrl);
    } catch (_err) {
        previewWindow.document.open();
        previewWindow.document.write(html);
        previewWindow.document.close();
    }
    setTimeout(() => {
        URL.revokeObjectURL(htmlUrl);
        URL.revokeObjectURL(imageUrl);
    }, 120000);
}

export function getFilenameFromContentDisposition(contentDisposition) {
    if (!contentDisposition) return null;
    const match = /filename="?([^"]+)"?/i.exec(contentDisposition);
    return match?.[1] ?? null;
}

/** Hand a Blob to the browser's download flow under ``filename``. */
export function downloadBlob(blob, filename) {
    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.download = filename;
    document.body.appendChild(link);
    link.click();
    link.remove();
    URL.revokeObjectURL(url);
}
